module.exports = __webpack_public_path__ + "img/services.dcd44d38.svg";